import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TrackedTimeDataBuilder } from './tracked-time-data.builder';
import { TrackedTimeDataDispatcher } from './tracked-time-data.dispatcher';
import { TrackedTimeDataEffects } from './tracked-time-data.effects';
import { FEATURE_NAME, reducer } from './tracked-time-data.reducer';
import { TrackedTimeDataService } from './tracked-time-data.service';
import { TrackedTimeDataStore } from './tracked-time-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([TrackedTimeDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class TrackedTimeDataModule {
  static forRoot(): ModuleWithProviders<TrackedTimeDataModule> {
    return {
      ngModule: TrackedTimeDataModule,
      providers: [
        TrackedTimeDataDispatcher,
        TrackedTimeDataService,
        TrackedTimeDataStore,
        TrackedTimeDataBuilder,
      ],
    };
  }
}
